import type { ReactNode } from 'react';
import classes from './DetailList.module.css';

/** Stacks {@link DetailRow}s as a read-only list of labelled values. */
// @ai-generated 2026-10-30T09:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function DetailList({ children }: { children: ReactNode }) {
    return <dl className={classes.list}>{children}</dl>;
}

interface IDetailRowProps {
    label: string;
    children: ReactNode;
}

/** One label with its value, which can be text or several elements such as a text and a button. */
// @ai-generated 2026-10-30T09:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function DetailRow({ label, children }: IDetailRowProps) {
    return (
        <div className={classes.row}>
            <dt className={classes.label}>{label}</dt>
            <dd className={classes.value}>{children}</dd>
        </div>
    );
}
